var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsCrowdenergy201(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 99.2 99.2",
    style: {
      enableBackground: "new 0 0 99.2 99.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#c8d1c5",
    d: "M81.6,25.7C76,18.8,67.8,15.2,59.5,15.2c-6.3,0-12.7,2.1-17.9,6.4c-6.9,5.6-10.5,13.8-10.5,22.1 c0,4.5,1.1,9.1,3.3,13.3L13.3,74.1c-1.3,1.1-2.1,2.7-2,4.3c0,1.2,0.4,2.5,1.2,3.5c1.1,1.3,2.7,2.1,4.3,2c1.2,0,2.5-0.4,3.5-1.2 l21.2-17.2c5.2,4.3,11.6,6.5,18.1,6.5c6.3,0,12.7-2.1,17.9-6.4l-0.6-0.8l0.6,0.8C84.4,60,88,51.9,88,43.6 C88,37.3,85.9,31,81.6,25.7z M19,81.2c-0.7,0.5-1.5,0.8-2.2,0.8c-1,0-2.1-0.4-2.8-1.3c-0.5-0.7-0.8-1.5-0.8-2.2 c0-1,0.4-2.1,1.3-2.8l20.9-17c0.6,1,1.3,2,2.1,2.9c0.8,0.9,1.6,1.8,2.4,2.6L19,81.2z M76.2,64.1L76.2,64.1 c-4.9,4-10.8,5.9-16.7,5.9c-7.7,0-15.3-3.3-20.5-9.7c-4-4.9-5.9-10.8-5.9-16.7c0-7.7,3.3-15.3,9.7-20.5c4.9-4,10.8-5.9,16.7-5.9 c7.7,0,15.3,3.3,20.5,9.7c4,4.9,5.9,10.8,5.9,16.7C86,51.3,82.6,58.9,76.2,64.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8d1c5",
    d: "M77.2,29.2c-4.5-5.5-11.1-8.4-17.7-8.4c-5.1,0-10.2,1.7-14.4,5.1c-5.5,4.5-8.4,11.1-8.4,17.7 c0,5.1,1.7,10.2,5.1,14.4c4.5,5.5,11.1,8.4,17.7,8.4c5.1,0,10.2-1.7,14.4-5.1l-0.6-0.8l0.6,0.8c5.5-4.5,8.4-11.1,8.4-17.7 C82.4,38.6,80.7,33.5,77.2,29.2z M72.7,59.8L72.7,59.8c-3.9,3.1-8.5,4.7-13.1,4.7c-6,0-12-2.6-16.1-7.7c-3.1-3.9-4.7-8.5-4.7-13.1 c0-6,2.6-12,7.7-16.1c3.9-3.1,8.5-4.7,13.1-4.7c6,0,12,2.6,16.1,7.7c3.1,3.9,4.7,8.5,4.7,13.1C80.4,49.7,77.7,55.6,72.7,59.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCrowdenergy201);
export default __webpack_public_path__ + "static/media/icons-crowdenergy-201.45fe532c268ca2cf2edca01461348b61.svg";
export { ForwardRef as ReactComponent };